"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _reactRouterDom = require("react-router-dom");
var _propTypes = _interopRequireDefault(require("prop-types"));
var _useBreakPoint = require("../../../../common/useBreakPoint");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
(function () {
  const styles = ":export {\n  primary-SIAblack: #000000;\n  primary-SIAgraydark: #4c4c4c;\n  primary-SIAgrayMiddle: #a8a8a8;\n  primary-SIAgray: #d4d4d4;\n  primary-SIAgrayLight: #e8e8e8;\n  primary-SIAgrayVeryLight: #f4f4f4;\n  primary-SIAwhite: #fff;\n  primary-SIAred: #e41b13;\n  primary-SIAredDark: #99100a;\n  secondary-SIAazure: #8caddb;\n  secondary-SIAazureLight: #e9eff7;\n  secondary-SIAbronze: #b1997e;\n  secondary-SIAbronzeLight: #efebe5;\n  secondary-SIAgreen: #2fb789;\n  secondary-SIAgreenLight: #ecf7f3;\n  secondary-SIAorange: #f3743d;\n  secondary-SIAorangeLight: #fbf1ec;\n  secondary-SIArose: #e6005f;\n  secondary-SIAroseLight: #fcf2f7;\n  secondary-SIAyellow: #dacd7e;\n  secondary-SIAyellowLight: #faf8ed; }\n\n.EventSpeaker-container {\n  display: flex;\n  flex-direction: column;\n  text-decoration: none;\n  box-sizing: content-box;\n  min-width: 244px;\n  width: auto; }\n  .EventSpeaker-container .info-container {\n    display: flex;\n    flex-direction: column;\n    max-width: 214px;\n    width: auto; }\n  .EventSpeaker-container img {\n    width: 100%;\n    height: auto;\n    aspect-ratio: 1;\n    object-fit: cover; }\n  .EventSpeaker-container .name {\n    margin-bottom: 0px;\n    max-width: 100%; }\n  .EventSpeaker-container .professional_function {\n    max-width: 204px; }\n  .EventSpeaker-container .diploma_title {\n    margin-top: 2px; }\n\n@media (max-width: 42rem) {\n  .EventSpeaker-container {\n    max-width: 312px; }\n    .EventSpeaker-container .info-container {\n      max-width: 288px;\n      width: auto;\n      margin-left: 0px; } }\n";
  const fileName = "EventSpeaker_EventSpeaker";
  const element = document.querySelector("style[data-sass-component='EventSpeaker_EventSpeaker']");
  if (!element) {
    const styleBlock = document.createElement("style");
    styleBlock.innerHTML = styles;
    styleBlock.setAttribute("data-sass-component", fileName);
    document.head.appendChild(styleBlock);
  } else {
    element.innerHTML = styles;
  }
})();
const EventSpeaker = props => {
  const {
    picture,
    firstname,
    lastname,
    academic_title,
    diploma_title,
    work_function,
    email,
    gender,
    url,
    contact_urls
  } = props;
  const {
    isDesktop,
    isTablet,
    isMobile
  } = (0, _useBreakPoint.useBreakPoint)();
  const speaker_gender = gender ? gender : 'M';
  const content = /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, picture ? /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, isDesktop && /*#__PURE__*/_react.default.createElement("img", {
    className: "sia-margin-02-bottom",
    src: picture[0]?.desktop?.url || picture[0]?.original?.url
  }), isTablet && /*#__PURE__*/_react.default.createElement("img", {
    className: "sia-margin-02-bottom",
    src: picture[0]?.tablet?.url || picture[0]?.original?.url
  }), isMobile && /*#__PURE__*/_react.default.createElement("img", {
    className: "sia-margin-02-bottom",
    src: picture[0]?.mobile?.url || picture[0]?.original?.url
  })) : /*#__PURE__*/_react.default.createElement("img", {
    className: "sia-margin-02-bottom",
    src: `/images/defaultEmployee_${speaker_gender}.jpg`
  }), /*#__PURE__*/_react.default.createElement("div", {
    className: "info-container sia-padding-04-bottom "
  }, /*#__PURE__*/_react.default.createElement("h3", {
    className: "name sia-text-12"
  }, `${academic_title?.[0]?.name || ''} ${firstname}`), /*#__PURE__*/_react.default.createElement("h3", {
    className: "lastname sia-text-12 sia-margin-02-bottom"
  }, lastname), /*#__PURE__*/_react.default.createElement("p", {
    className: "work_function sia-text-03",
    dangerouslySetInnerHTML: {
      __html: work_function
    }
  }), /*#__PURE__*/_react.default.createElement("p", {
    className: "diploma_title sia-text-08"
  }, diploma_title), email && /*#__PURE__*/_react.default.createElement("p", {
    className: "email sia-text-08 sia-margin-02-top"
  }, /*#__PURE__*/_react.default.createElement("a", {
    href: `mailto:${email}`
  }, "E-Mail")), contact_urls && contact_urls.length > 0 && contact_urls.map((el, index) => /*#__PURE__*/_react.default.createElement("p", {
    className: "url sia-text-08 sia-margin-02-top",
    key: index
  }, /*#__PURE__*/_react.default.createElement("a", {
    href: el.url.original_url,
    target: "_blank",
    rel: "noopener noreferrer"
  }, el.url.original_url)))));
  return url ? /*#__PURE__*/_react.default.createElement(_reactRouterDom.Link, {
    className: "EventSpeaker-container sia-border-01-bottom sia-margin-02-bottom",
    to: url
  }, content) : /*#__PURE__*/_react.default.createElement("div", {
    className: "EventSpeaker-container sia-border-01-bottom sia-margin-02-bottom"
  }, content);
};
EventSpeaker.propTypes = {
  picture: _propTypes.default.object,
  academic_title: _propTypes.default.object,
  firstname: _propTypes.default.string,
  lastname: _propTypes.default.string,
  diploma_title: _propTypes.default.string,
  work_function: _propTypes.default.string,
  url: _propTypes.default.string,
  email: _propTypes.default.string,
  gender: _propTypes.default.string,
  contact_urls: _propTypes.default.array
};
var _default = exports.default = EventSpeaker;